import http from './http'
export default class tlpConfigApi {
	static checkDomain (params) {
		return http.httpGet('/publish/check', params)
	}
	static cyberDomain (params) {
		return http.httpGet('/publish/rushDomain', params)
	}

	static checkMineDomain (params) {
		return http.httpGet('/publish/checkMineDomain', params)
	}

	static bindMineDomain (params) {
		return http.httpGet('/publish/bindMineDomain', params)
	}

	static getSkin (params) {
		return http.httpGet('/edit/skin', params)
	}

	/*保存最佳方案*/
	static saveBestskin (data = null, params) {
		return http.httpPut('/edit/bestskin', data, params)
	}

	static saveSkin (data = null, params) {
		return http.httpPut('/edit/skin', data, params)
	}

	/*baocun信息*/
	static saveConfigInfo (data) {
		return http.httpPost('/project/config', data)
	}

	/*fabu*/
	static publishProj (params) {
		return http.httpGet('/publish/project', params)
	}

	static getProgress (params) {
		return http.httpGet('/common/progress', params)
	}
	/**
	 * 获取搜索引擎抓取页面数量
	 * @param params
	 * @returns {*}
	 */
	static getSearchNumber (params) {
		return http.httpGet('/search/engines/number', params)
	}
	static uploadIco (data) {
		return http.httpPost('/auth/common/coveredfile', data)
	}
	static getCommonInfo () {
		return http.httpGet('/auth/common/getCommonInfo')
	}

	static setProjSeo (data) {
		return http.httpPost('/lavrock/project/configseo', data)
	}

	static getDoneDomain () {
		return http.httpGet('/project/domain?isUse=true')
	}
	static updateFtpDomain (params) {
		return http.httpPut('/project/ftp', null, params)
	}
	/**
	 * 保存Robots,设置右键禁止
	 * @param {*} params
	 */
	static putRobotsSave (params) {
		return http.httpPut('/project/config/body', params)
	}
	/**
	 * 获取项目域名
	 * @param {*} params
	 */
	static getRobotsDomain (params) {
		return http.httpGet('/project/single/domain', params)
	}
	/**
	 * 上传验证文件
	 * @param {*} params
	 */
	static postCoveredfile (data, params) {
		return http.httpPost('/lavrock/auth/common/coveredfile', data, params)
	}
	/**
	 * 获取3Stoken
	 * @param {*} params
	 */
	static getCustomerServeToken (params) {
		return http.httpGet('/work/getCustomerServeToken', params)
	}
	/**
	 * 查询是否开通3S
	 * @param {*} params
	 */
	static getOpenCustomerServe (data) {
		return http.httpGet('/work/openCustomerServe', data)
	}
	/**
	 * 查询客服询盘数据
	 * @param {*} params
	 */
	static getBattleshipCustomerCount (data, params) {
		return http.httpPost('/work/getBattleshipCustomerCount', data, params)
	}

	/**
	 * 查询客服js和开启状态接口
	 * @param {*} params
	 */
	static getForeignSnsAccount (data) {
		return http.httpGet('/work/getForeignSnsAccount', data)
	}

	/**
	 * 开启或关闭客服探头
	 * @param {*} params
	 */
	static updateSnsAccount (data) {
		return http.httpPost('/work/updateSnsAccount', '', data)
	}
	/**
	 * 查询当日3s询盘数据
	 * @param {*} params
	 */
	static getTodayInquiryData (data) {
		return http.httpGet('/work/getTodayInquiryData', data)
	}
	/**
	 * 返回项目所有的产品文章 data.json
	 * @param {*} params
	 */
	static getProjectProdDesc (data) {
		return http.httpGet('/project/getProjectProdDesc', data)
	}
	/**
	 * @description:获取所有城市分级信息
	 * @param {*} data
	 * @return {*}
	 */
	static getHierarchicalAreaList (data) {
		return http.httpGet('/subSite/getHierarchicalAreaList', data)
	}
	/**
	 * @description: 根据项目ID获取项目分站配置信息
	 * @param {*} data
	 * @return {*}
	 */
	static getSubSite (data) {
		return http.httpGet('/subSite/getSubSite', data)
	}

	/**
	 * 保存分站配置信息 第一次保存调用
	 * @param {*}
	 * projectId 项目ID
	 * mainArea 主营区域
	 * allSubSite 全国业务范围
	 * whetherSyncSubSite  发布是否同步分站
	 */
	static saveSubSitev (data) {
		return http.httpPost('/subSite/saveSubSite', data)
	}
	/**
	 * 更新分站配置信息
	 * @param {*}
	 * _id 分站配置信息ID
	 * projectId 项目ID
	 * mainArea 主营区域
	 * allSubSite 全国业务范围
	 * whetherSyncSubSite  发布是否同步分站
	 */
	static updateSubSite (data) {
		return http.httpPut('/subSite/updateSubSite', data)
	}

}
